import React from 'react';
import { Box, Typography, Grid, Container, Paper, Button,Divider, Avatar } from '@mui/material';
import Lottie from 'lottie-react';
import animationCraftsmanship from '../lotties/craftsmanship.json';
import animationSustainability from '../lotties/sustainability.json';
import animationCustomer from '../lotties/customer-centric.json';
import animationGreenHomes from '../lotties/GreenHomes.json';

import Section_3 from '../Section_3/Section_3';

const AboutUrbanCasa = (
  { ownerName = "Mr. Perminderjit Singh",
  ownerDesignation = "Director",
  ownerMessage = "At our company, we believe quality and customer satisfaction come first. Our team is dedicated to bringing your vision to life with precision and passion.",
  ownerImage = "/assets/directorphoto.jpg", // pass image URL or null
  }
) => {
  
  return (
    <Box sx={{ bgcolor: '#0D0D0D', color: 'white', overflowX: 'hidden' }}>
      {/* Hero Section */}
      <Box
        sx={{
          minHeight: '80vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          textAlign: 'center',
          backgroundImage: "url('/assets/display-photo-2.jpg')",
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          position: 'relative',
          backgroundRepeat:'no-repeat',
          '&::before': {
            content: '""',
            position: 'absolute',
            inset: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.8)',
            zIndex: 1,
          },
        }}
      >
        <Box sx={{ position: 'relative', zIndex: 2, px: 3 }}>
          <Typography variant="h1" sx={{ fontWeight: 900, mb: 2, fontSize: { xs: '2.5rem', md: '1vw' },fontFamily: 'Playfair Display' }}>
             <h1 className="text-[3vw] font-bold text-white leading-[1.3] " >
         Build Your Dream With{" "}
          <span className="text-[#d4af37]">Urban Casa</span>
        </h1>
          </Typography>
          <Typography variant="h6" sx={{ opacity: 0.8, maxWidth: 700, mx: 'auto' }}>
            Custom Homes Designed for the Modern World. Built with Precision, Style, and Sustainability.
          </Typography>
        </Box>
      </Box>

      {/* Who We Are */}
      {/* <Container sx={{ py: 10 }}>
        <Grid container spacing={6} alignItems="center">
          <Grid item xs={12} md={6}>
            <Typography variant="h3" sx={{ fontWeight: 800, mb: 3 }}>
              Who We Are
            </Typography>
            <Typography variant="body1" sx={{ lineHeight: 1.8, color: '#bbb' }}>
              Urban Casa is Australia’s premier custom home builder committed to crafting innovative,
              sustainable, and highly personalized living spaces. With over 4 years of excellence in the
              construction industry, our experienced architects, designers, and builders collaborate
              closely with each client to bring their unique vision to life.
              <br /><br />
              Whether you’re looking to create your first home, a forever home, or invest in sustainable
              architecture, we guide you through every step with professionalism, creativity, and care.
            </Typography>
          </Grid>
          <Grid item xs={12} md={4}>
            <Box component="img" src="/assets/urbanCasa_logo.png" alt="Team" sx={{ width: '100%', borderRadius: 3 }} />
          </Grid>
        </Grid>
      </Container> */}
<Section_3/>
      {/* Mission */}
      <Box
      sx={{
        py: { xs: 6, md: 10 },
        bgcolor: "#0c0c0c",
        color: "white",
        textAlign: "center",
        position: "relative",
        overflow: "hidden",
      }}
    >
      {/* Golden Glow Decorative Circle */}
      <Box
        sx={{
          position: "absolute",
          top: "-100px",
          right: "-100px",
          width: "300px",
          height: "300px",
          background: "radial-gradient(circle, #d4af37 0%, transparent 70%)",
          zIndex: 0,
          opacity: 0.1,
        }}
      />

      <Container maxWidth="md" sx={{ position: "relative", zIndex: 2 }}>
        <Typography
          variant="h4"
          sx={{
            fontWeight: 700,
            fontSize: { xs: "2rem", md: "2.8rem" },
            color: "#d4af37",
            letterSpacing: 1,
            mb: 2,
          }}
        >
          OUR MISSION
        </Typography>

        <Divider
          sx={{
            width: "60px",
            height: "4px",
            backgroundColor: "#d4af37",
            mx: "auto",
            mb: 4,
            borderRadius: 5,
          }}
        />
<Typography
          variant="h4"
          sx={{
            fontWeight: 700,
            fontSize: { xs: "2rem", md: "1.4rem" },
            color: "#37d459ff",
            letterSpacing: 1,
            mb: 2,
          }}
        >
          Build Your Dream
        </Typography>
        <Typography
          variant="body1"
          sx={{
            color: "#ccc",
            fontSize: { xs: "1rem", md: "1.125rem" },
            lineHeight: 1.9,
            maxWidth: "700px",
            mx: "auto",
          }}
        >
          At <strong>Urban Casa Constructions</strong>, our mission is to deliver exceptional, custom-built
          homes that embody your lifestyle and values. Through creative collaboration, architectural
          excellence, and sustainable innovation, we craft living spaces that inspire — from foundation to finish.
        </Typography>
      </Container>
    </Box>

      {/* Services Summary */}
<Container
  disableGutters
  maxWidth={false}
  sx={{
    width: '100%',
    minHeight: '100vh',
    backgroundImage: "url('/assets/display-photo-2.jpg')",
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    position: 'relative',
    px: { xs: 2, md: 10 },
    py: 8,
    '&::before': {
      content: '""',
      position: 'absolute',
      inset: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.7)',
      zIndex: 1,
    },
  }}
>
  <Typography
    variant="h4"
    sx={{
      fontWeight: 700,
      textAlign: 'center',
      mb: 6,
      color: '#d4af37',
      letterSpacing: 1.2,
      fontSize: { xs: '2rem', md: '2.8rem' },
      textTransform: 'uppercase',
      zIndex: 2,
      position: 'relative',
    }}
  >
    What We Do
  </Typography>

  <Grid container spacing={4} justifyContent="center" sx={{ zIndex: 2, position: 'relative' }}>
    {[
      'Custom Design & Architecture',
      'New Construction & Build',
      'Home Renovations & Additions',
      'Eco-Friendly Smart Living',
      'Interior & Exterior Design',
    ].map((service, i) => (
      <Grid item xs={12} sm={6} md={4} lg={3} key={i}>
        <Paper
          elevation={0}
          sx={{
            p: 4,
            backdropFilter: 'blur(8px)',
            background: 'rgba(255, 255, 255, 0.08)',
            border: '1px solid rgba(212, 175, 55, 0.3)',
            borderRadius: 3,
            color: '#fff',
            textAlign: 'center',
            fontSize: '1.15rem',
            fontWeight: 600,
            minHeight: '150px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            boxShadow: '0 4px 20px rgba(0,0,0,0.2)',
            transition: 'all 0.3s ease-in-out',
            '&:hover': {
              transform: 'scale(1.05)',
              borderColor: '#d4af37',
              boxShadow: '0 0 30px #d4af37aa',
            },
          }}
        >
          {service}
        </Paper>
      </Grid>
    ))}
  </Grid>
</Container>




      {/* Values with Lottie Animations */}
      <Box sx={{ bgcolor:"black", py: 10 }}>
        <Container>
          <Typography variant="h4" sx={{ fontWeight: 700, mb: 6, textAlign: 'center' }}>
            Our Core Values
          </Typography>
       <Grid container spacing={6}>
  {/* Sustainability */}
  <Grid item xs={12} md={4}>
    <Paper sx={{ p: 4, bgcolor: '#1e1e1e', textAlign: 'center', borderRadius: "40px" }}>
      <Lottie animationData={animationSustainability} style={{ height: 140 }} />
      <Typography sx={{ mt: 2, fontSize: "1.6vw" }} className='text-[#d4af37]'>Sustainability</Typography>
      <Typography variant="body2" sx={{ mt: 1, color: '#ccc', width: "32vw" }}>
        We use eco-conscious materials and energy-efficient technologies in all projects.
      </Typography>
    </Paper>
  </Grid>

  {/* Customer-Centric */}
  <Grid item xs={12} md={4}>
    <Paper sx={{ p: 4, bgcolor: '#1e1e1e', textAlign: 'center', borderRadius: "40px" }}>
      <Lottie animationData={animationCustomer} style={{ height: 140 }} />
      <Typography sx={{ mt: 2, fontSize: "1.6vw" }} className='text-[#d4af37]'>Customer-Centric</Typography>
      <Typography variant="body2" sx={{ mt: 1, color: '#ccc' }}>
        Your satisfaction is our priority. We tailor the journey to your needs.
      </Typography>
    </Paper>
  </Grid>

  {/* Green Homes */}
  <Grid item xs={12} md={4}>
    <Paper sx={{ p: 4, bgcolor: '#1e1e1e', textAlign: 'center', borderRadius: "40px" }}>
      <Lottie animationData={animationGreenHomes} style={{ height: 140 }} />
      <Typography sx={{ mt: 2, fontSize: "1.6vw" }} className='text-[#d4af37]'>Green Homes</Typography>
      <Typography variant="body2" sx={{ mt: 1, color: '#ccc', width: "32vw" }}>
        We design homes surrounded by lush greenery, gardens, and nature-friendly landscapes.
      </Typography>
    </Paper>
  </Grid>
</Grid>

        </Container>
      </Box>

      {/* CTA Section */}
      <Box sx={{ bgcolor: '#0D0D0D', textAlign: 'center', py: 8 }}>
        <Typography variant="h4" sx={{ fontWeight: 700, mb: 2 }}>
          Ready to Build with Urban Casa?
        </Typography>
        <Button
          variant="contained"
          sx={{ mt: 2, px: 4, py: 1.5, bgcolor: '#00FFB3', color: '#000', fontWeight: 700 }}
          href="/contact"
        >
          Schedule Your Free Consultation
        </Button>
      </Box>
       <Box sx={{ bgcolor: '#121212', py: 10, color: 'white' }}>
      <Container maxWidth="md">
        <Paper
          elevation={6}
          sx={{
            p: { xs: 4, md: 6 },
            display: 'flex',
            flexDirection: { xs: 'column', md: 'row' },
            alignItems: 'center',
            gap: 4,
            borderRadius: 3,
            backgroundColor: '#1e1e1e',
          }}
        >
          {ownerImage && (
            <Avatar
              src={ownerImage}
              alt={ownerName}
              sx={{ width: 120, height: 120, borderRadius: 3, flexShrink: 0 }}
              variant="rounded"
            />
          )}

          <Box sx={{ flex: 1 }}>
            <Typography
              variant="body1"
              sx={{ fontSize: '1.15rem', fontStyle: 'italic', mb: 4, lineHeight: 1.6,color:"white" }}
            >
              “{ownerMessage}”
            </Typography>

            <Typography variant="h6" sx={{ fontWeight: 700, color:"#d4af37" }}>
              {ownerName}
            </Typography>
            <Typography variant="subtitle1" sx={{ color: 'gray' }}>
              {ownerDesignation}
            </Typography>
          </Box>
        </Paper>
      </Container>
    </Box>
    </Box>
    
  );
};

export default AboutUrbanCasa;
